import { IInvoiceChildField } from "shared";

import { Paragraph } from "../../Atoms/Typography/Paragraph";

interface ChildFieldsProps {
  childFields: IInvoiceChildField[];
}

export function ChildFields({
  childFields,
}: ChildFieldsProps) {
  if (!childFields) {
    return null;
  }

  return (
    <div>
      {
        childFields.map(f => {
          return (
            <div key={ f.name + f.value }>
              <Paragraph>
                { `${f.name}: ` }
                <Paragraph
                  as={ `span` }
                  variant={ `secondary` }
                >
                  { f.value }
                </Paragraph>
              </Paragraph>
            </div>
          );
        })
      }
    </div>
  );
}
